import { Box, Grid, Typography } from "@mui/material";
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import CircularProgress from '@mui/material/CircularProgress';
import CancelIcon from '@mui/icons-material/Cancel';
import { useCallback, useEffect, useState, useRef } from "react";
import { useAxios } from "../../context/AxiosHookContext";

const FileComponent = ({ file = {}, onDelete }) => {
    const [currentFile, setFile] = useState(file);
    const [loadinImage, setLoadingImage] = useState(false);
    const axios = useAxios();


    const removeFile = async (e) => {
        e.preventDefault();
        e.stopPropagation();

        try {
            await axios.delete(`/files/${currentFile._id}`);
            onDelete(currentFile._id)
        } catch (error) {
            console.log(error)
        }
    }


    const getImageStyles = (file) => {

        const isImage = file.file_extension.includes("png", "jpg", "jpeg", "gif", "svg", "webp", "tiff", "bmp")

        const backgroundImage = isImage ? file.dataUrl : file.file_extension === "pdf" ? '/assets/pdf.webp' : '/assets/folder.webp';

        return {
            backgroundImage: `url(${backgroundImage})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat"
        }

    }
    const loadImage = useCallback(async (open) => {
        try {
            setLoadingImage(true);

            // Si ya está cargada la imagen y no se pidió abrir, salimos
            if (currentFile.loaded && !open) return;

            // Obtenemos la URL de descarga
            const { data: { data: downloadUrl } } = await axios.get(`/files/${currentFile._id}`);

            // Si se pidió abrir en otra pestaña, lo hacemos y salimos
            if (open) {
                window.open(downloadUrl, "_blank");
                return;
            }

            // Validamos si el archivo es una imagen (forma robusta)
            const extension = currentFile?.file_extension?.toLowerCase() || "";
            const imageExtensions = ["png", "jpg", "jpeg", "gif", "svg", "webp", "tiff", "bmp"];
            const isImage = imageExtensions.includes(extension);

            if (!isImage) return; // No procesamos si no es imagen

            // Descargamos la imagen como blob
            const { data: blob } = await axios.get(downloadUrl, {
                responseType: 'blob'
            });

            // Convertimos el blob a Data URL
            const url = await new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.onloadend = () => resolve(reader.result);
                reader.onerror = reject;
                reader.readAsDataURL(blob);
            });

            // Guardamos la data URL solo si es una imagen
            setFile(prev => ({
                ...prev,
                loaded: true,
                dataUrl: url
            }));

        } catch (error) {
            console.error("Error al cargar imagen:", error);
        } finally {
            setLoadingImage(false);
        }
    }, [setFile, currentFile]);


    useEffect(() => {

        loadImage()

    }, [loadImage]);


    return (
        <Box>
            <Box xs={12} sx={{ ...style.mainBox, ...getImageStyles(currentFile) }} key={currentFile._id}
                onClick={() => {
                    loadImage(true)
                }}
            >
                <CancelIcon sx={{ ...style.cancelIcon }} onClick={removeFile} />
                {loadinImage && <CircularProgress size={20} backgroundColor="#2065D1" />}
            </Box>
            <Typography sx={{
                width: style.mainBox.width, fontSize: 10,
                margin: "-15px 20px",
            }} >
                {currentFile.filename}
            </Typography>
        </Box>
    )
}

export default function UploadFilesDrive({ files = [], onLoadFile }) {
    const [filesList, setFileList] = useState(files)
    const axios = useAxios();
    const [loadingFile, setLoadingFile] = useState(false)
    const fileInputRef = useRef(null);
    const [number, setNumber] = useState(0);
    const [length, setLength] = useState(0);

    const onSelectItems = async (event) => {
        try {
            setLoadingFile(true);
            const selectedInputFiles = event?.target.files || [];

            if (selectedInputFiles.length > 0) {
                for (const key in Object.keys(selectedInputFiles)) {

                    setNumber(preconnect => preconnect + 1)
                    setLength(selectedInputFiles.length)
                    const file = selectedInputFiles[key];
                    const form = new FormData();
                    form.append('file', file);

                    try {
                        const { data: { data } } = await axios.post(`/files/saveFile`, form);

                        const fileDb = {
                            _id: data._id,
                            filename: data.file_name,
                            file_extension: data.file_extension,
                            oneDriveId: data.file_onedrive.id
                        };

                        // ✅ Siempre toma el estado más reciente
                        setFileList(prev => [...prev, fileDb]);

                    } catch (error) {
                        console.error("Error al subir archivo", error);
                        continue;
                    }
                }
            }

        } catch (error) {
            console.error("Error general en onSelectItems", error);
        } finally {
            if (fileInputRef.current) {
                fileInputRef.current.value = "";
            }
            setLoadingFile(false);
            setNumber(0)
            setLength(0)
        }
    };

    const deleteFile = (fileId) => {
        setFileList(prev => {
            return prev.filter(file => file._id !== fileId)
        })
    }

    useEffect(() => {
        onLoadFile(filesList)
    }, [filesList])

    return (

        <Grid container width={"100%"} >

            <Box xs={12} sx={{ ...style.mainBox }} htmlFor="input-load-file" component={"label"}>

                {loadingFile ?

                    (
                        <>
                            <CircularProgress size={20} backgroundColor="#2065D1" />
                            <Typography sx={{ fontSize: 13, marginTop: 1 }}>
                                {number}/{length}
                            </Typography>
                        </>
                    )


                    :
                    <>
                        <CloudUploadIcon sx={{ fontSize: 40, color: "#4f0a5270" }} />
                        <input
                            onChange={onSelectItems}
                            ref={fileInputRef}
                            type="file"
                            style={{ display: "none" }}
                            id="input-load-file"
                            multiple
                            accept=".png, .jpeg, .jpg, .pdf, .xls, .xlsx, .zip, .rar"
                        />

                        <Typography sx={{ fontSize: 11, marginTop: 1,fontWeight: "bold" }}>
                            Cargar documentos
                        </Typography>
                    </>
                }
            </Box>

            {
                filesList?.map((item) => (
                    <FileComponent file={item} key={item._id} onDelete={deleteFile} />
                ))
            }
        </Grid>
    )

}

const style = {
    cancelIcon: {
        position: "absolute",
        top: -7,
        right: -5,
        color: "#8a6060",
        "&:hover": {
            color: "#8a6060"
        },
    },
    mainBox: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "#edd8d8",
        height: 100,
        width: 120,
        borderRadius: 1,
        cursor: "pointer",
        marginTop: 2,
        marginRight: 2,
        padding: 1,
        position: "relative"
    }
}